import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getArrayItemAt',
  standalone: false
})
export class GetArrayItemAtPipe implements PipeTransform {
  transform<T>(value: T[], index: number): T | null {
    return value?.[index] ?? null;
  }
}
